export default __webpack_public_path__ + "static/media/492.efb82a3f.gif";